/**
 * Anel de foco do teclado (Feed REDE-22, Extrato PREM-22): azul-escuro, 2px e afastado do elemento, com contraste
 * acima de 3:1 sobre o amarelo, o branco e o cinza da página.
 */
export const FOCO_VISIVEL =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-blue-dark';

/**
 * Mesmo anel em branco, para textos sobre o azul da marca (o azul-escuro some ali): 4,88:1
 * contra o `brand-blue`.
 */
export const FOCO_SOBRE_AZUL =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-white';
